/**
 * Read the async-recheck result for the lead-detail "Possible Dentally match" badge.
 *
 * Backend contract: the lead detail serializers (retrieve, with or without
 * ?slim=true) expose `dentally_possible_match` as either `null` or
 * `{ "status": "MATCHED", "candidates": [{ dentally_patient_id, signals }] }` (no names / DOB). The BE already returns
 * null once the lead is linked to a Dentally patient. Returns the candidates array
 * ([] when none).
 */
export function getDentallyPossibleMatch(lead) {
    const match = lead?.dentally_possible_match;
    return Array.isArray(match?.candidates) ? match.candidates : [];
}
